import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/thumbs";
import "swiper/css/free-mode";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import StarIcon from "@mui/icons-material/Star";
import Rating from "@mui/material/Rating";
import YouTubeIcon from "@mui/icons-material/YouTube";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import HeaderImg from "../../assets/Thumbnailheaderelloris.png";
import AddonsOffCanvas from "../Addons/AddonsOffCanvas";
import ShareIcon from "../../assets/icons/Share Icon.png";
import BeforeWhishlistIcon from "../../assets/icons/Fav Before Icon.png";
import AfterWishlistIcon from "../../assets/icons/Fav After Icon.png";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import EmailIcon from "@mui/icons-material/Email";
// Product image
import Image1 from "../../assets/images/product/Mellow_Soft_A.jpg";
import Image2 from "../../assets/images/product/Mellow_Soft_B.jpg";
import Image3 from "../../assets/images/product/Mellow_Soft_C.jpg";
import Image4 from "../../assets/images/product/Mellow_Soft_D.jpg";
import Image5 from "../../assets/images/product/Mellow_Soft_E.jpg";
import Image6 from "../../assets/images/product/Mellow_Soft_F.jpg";

//Thickness icons (active/inactive)
import Icon6Active from "../../assets/icons/01.png";
import Icon6Inactive from "../../assets/icons/02.png";
import Icon8Active from "../../assets/icons/03.png";
import Icon8Inactive from "../../assets/icons/04.png";
import Icon10Active from "../../assets/icons/05.png";
import Icon10Inactive from "../../assets/icons/06.png";

//Size icons (active/inactive)
import IconSingleActive from "../../assets/icons/07.png";
import IconSingleInActive from "../../assets/icons/08.png";
import IconQueenActive from "../../assets/icons/09.png";
import IconQueenInactive from "../../assets/icons/10.png";
import IconKingActive from "../../assets/icons/11.png";
import IconKingInactive from "../../assets/icons/12.png";

//Custom Size icons
import CustomSizeActive from "../../assets/icons/13.png";
import CustomSizeInActive from "../../assets/icons/14.png";

//cover images
// import Aloevera from "../../assets/covers/image2.jpg";
import toast from "react-hot-toast";
import Radio from "@mui/material/Radio";
import CustomSizeModalBox from "./CustomSizeModalBox";

export default function ProductSpecifications() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const mainSwiperRef = useRef(null);

  //States
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedType, setSelectedType] = useState("single");
  const [customSizeActive, setCustomSizeActive] = useState(false);
  const [quantity, setQuantity] = useState(1);

  // Dropdown (dimension) states
  const [customDropdownOpen, setCustomDropdownOpen] = useState(false);
  const [dropdownThickNess, setDropdownThickNess] = useState(false);
  const [dropdownSize, setDropdowSize] = useState(false);
  const [selectedDimension, setSelectedDimension] = useState({
    value: "72x72",
    labelInch: "72x72 Inch",
    labelCm: "(182x182 cm)",
  });

  const images = [Image1, Image2, Image3, Image4, Image5, Image6];
  const [openAddons, setOpenAddons] = useState(false);

  const handlePrev = () => mainSwiperRef.current?.slidePrev();
  const handleNext = () => mainSwiperRef.current?.slideNext();

  const thicknessOptions = [
    {
      label: "6 Inch",
      value: "6",
      activeIcon: Icon6Active,
      inactiveIcon: Icon6Inactive,
    },
    {
      label: "8 Inch",
      value: "8",
      activeIcon: Icon8Active,
      inactiveIcon: Icon8Inactive,
    },
    {
      label: "10 Inch",
      value: "10",
      activeIcon: Icon10Active,
      inactiveIcon: Icon10Inactive,
    },
  ];
  const [selectedThickness, setSelectedThickness] = useState(
    thicknessOptions[0],
  );
  const SizeOptions = [
    {
      label: "Single",
      value: "Single",
      activeIcon: IconSingleActive,
      inactiveIcon: IconSingleInActive,
    },
    {
      label: "Queen",
      value: "Queen",
      activeIcon: IconQueenActive,
      inactiveIcon: IconQueenInactive,
    },
    {
      label: "King",
      value: "King",
      activeIcon: IconKingActive,
      inactiveIcon: IconKingInactive,
    },
  ];
  const [selectedSize, setSelectedSize] = useState(SizeOptions[0]);
  const dimensionOptions = [
    { value: "72x72", labelInch: "72x72 Inch", labelCm: "(182x182 cm)" },
    { value: "75x60", labelInch: "75x60 Inch", labelCm: "(190x152 cm)" },
    { value: "78x72", labelInch: "78x72 Inch", labelCm: "(198x182 cm)" },
  ];
  const wishlistItem = [
    {
      id: 1,
      name: "Ortho Latex Mattress",
      thickness: "6 Inch",
      size: "Single",
      dimension: "72x72 Inch 6 Inch",
      cover: "Aloe vera cover",
      originalPrice: "₹55,600",
      price: "₹44,480",
      image: Image1,
    },
  ];
  function handleAddWishList() {
    localStorage.setItem("wishlistitems", JSON.stringify(wishlistItem));
    toast.success("Item added to wishlist");
  }
  //Cover dropdown states
  // const [coverDropdownOpen, setCoverDropdownOpen] = useState(false);
  // const [selectedCover, setSelectedCover] = useState({
  //   value: "aloe",
  //   label: "Aloe vera cover",
  //   description: "Natural Aloe vera Infused Fiber",
  //   image: Aloevera,
  // });

  // const coverOptions = [
  //   {
  //     value: "aloe",
  //     label: "Aloe vera cover",
  //     description: "Natural Aloe vera Infused Fiber",
  //     image: Aloevera,
  //   },
  //   {
  //     value: "organic",
  //     label: "Organic Cotton Cover",
  //     description: "100% Eco-friendly Cotton Finish",
  //     image: Aloevera,
  //   },
  // ];
  const dimensionRef = useRef(null);
  const coverRef = useRef(null);
  const sizeRef = useRef(null);
  const thicknessRef = useRef(null);
  const [shareOpen, setShareOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const productUrl = window.location.href;

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(productUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShare = (platform) => {
    const encodedUrl = encodeURIComponent(productUrl);
    let shareUrl = "";

    switch (platform) {
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${encodedUrl}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}`;
        break;
      case "telegram":
        shareUrl = `https://t.me/share/url?url=${encodedUrl}`;
        break;
      default:
        return;
    }

    window.open(shareUrl, "_blank");
  };

  useEffect(() => {
    function handleClickOutside(event) {
      // Dimension dropdown
      if (
        dimensionRef.current &&
        !dimensionRef.current.contains(event.target)
      ) {
        setCustomDropdownOpen(false);
      }
      // Thickenss dropdown
      if (
        thicknessRef.current &&
        !thicknessRef.current.contains(event.target)
      ) {
        setDropdownThickNess(false);
      }
      // Size dropdown
      if (sizeRef.current && !sizeRef.current.contains(event.target)) {
        setDropdowSize(false);
      }
      // Cover dropdown
      if (coverRef.current && !coverRef.current.contains(event.target)) {
        // setCoverDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto   gap-8 ">
      {/* LEFT IMAGE SLIDER */}
      <div className="flex flex-col items-center xl:px-0 relative top-[3.7rem] xl:sticky xl:top-[4.4rem] bottom-2 h-fit">
        <Swiper
          onSwiper={(swiper) => (mainSwiperRef.current = swiper)}
          loop={true}
          spaceBetween={10}
          thumbs={{ swiper: thumbsSwiper }}
          modules={[Thumbs]}
          className="w-full max-w-[900px] xl:max-w-[600px] overflow-hidden  "
        >
          {images.map((img, index) => (
            <SwiperSlide key={index} className="cursor-pointer">
              <div className="relative overflow-hidden">
                {/* HEADER IMAGE */}
                <img
                  src={HeaderImg}
                  alt="Header"
                  className="w-full object-cover"
                />

                {/* MAIN IMAGE */}
                <img
                  src={img}
                  alt={`Thumbnail ${index + 1}`}
                  className="w-full object-cover rounded-none xl:rounded-b-2xl"
                />

                {/* LIKE & SHARE ICONS */}
                <div className="absolute bottom-4 right-4 flex gap-3 z-10">
                  {/* SHARE */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShareOpen(true);
                    }}
                  >
                    <img
                      src={ShareIcon}
                      alt="Share"
                      className="w-auto h-auto"
                    />
                  </button>

                  {/* LIKE */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsWishlisted((prev) => !prev);
                      handleAddWishList();
                    }}
                    className="transition-transform duration-200 hover:scale-110"
                  >
                    <img
                      src={
                        isWishlisted ? AfterWishlistIcon : BeforeWhishlistIcon
                      }
                      alt="Wishlist"
                      className="w-auto h-auto"
                    />
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* THUMBNAILS */}
        <div className="flex items-center justify-center gap-1 xl:gap-4 mt-4 mb-10 w-full">
          <button
            onClick={handlePrev}
            className="p-2 transition text-gray-400 hover:text-gray-600"
          >
            <ArrowBackIosNewIcon className="text-[14px] sm:text-[16px] xl:text-[25px]" />
          </button>

          <Swiper
            onSwiper={setThumbsSwiper}
            loop={true}
            slidesPerView={4}
            spaceBetween={10} // ✅ default → small screens
            breakpoints={{
              1280: {
                spaceBetween: 20, // ✅ xl & above
              },
            }}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Thumbs]}
            className="mySwiper flex-1"
          >
            {images.map((img, index) => (
              <SwiperSlide key={index} className="cursor-pointer">
                <img
                  src={img}
                  alt={`Thumbnail ${index + 1}`}
                  className="w-auto xl:h-auto object-cover rounded-lg"
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <button
            onClick={handleNext}
            className="p-2 transition text-gray-400 hover:text-gray-600"
          >
            <ArrowForwardIosIcon className="text-[14px] sm:text-[16px] xl:text-[25px]" />
          </button>
        </div>
      </div>

      {/* RIGHT SIDE PRODUCT DETAILS */}
      <div className="xl:py-16 py-10 sm:pt-4 px-7 xl:px-0 pb-4 xl:mt-[4.4rem]">
        {/* BADGE */}
        <p className="border border-[#204b97] bg-[#b1cdfd] py-1 text-[#204b97] font-lexend font-light text-[10px] xl:text-[16px] 3xl:text-running capitalize rounded-lg w-[30%] xl:w-[20%] justify-center flex items-center text-center">
          Best seller
        </p>

        {/* TITLE */}
        <h1 className="font-normal font-calsans text-[22px] xl:text-[52px] text-[#333333] pt-3 capitalize">
          Mellow Soft Series
        </h1>
        <p className="text-[12px] xl:text-running text-[#6d6d6d] font-lexend font-light">
          Built for those who want their rest to heal.
        </p>

        {/* RATING */}
        <div className="flex items-center gap-3 mt-3">
          <Rating
            name="product-rating"
            value={4.5}
            precision={0.5}
            readOnly
            icon={<StarIcon fontSize="inherit" sx={{ color: "#f2e390" }} />}
            emptyIcon={<StarIcon style={{ opacity: 0.3 }} fontSize="inherit" />}
          />
          <span className="text-[#3a683f] text-[10px]md:text-[14px] xl:text-[16px] font-light font-lexend bg-[#acd8b5] px-3 py-1 rounded-lg">
            4.5
          </span>
        </div>

        {/* DESCRIPTION */}
        <p className="text-[12px] xl:text-[16px] 3xl:text-running font-lexend font-light text-[#6d6d6d] py-5 xs:w-full sm:w-[85%] md:w-[90%]">
          The Ortho Latex Mattress offers firm orthopedic support, breathable
          comfort, and toxin-free materials—so your body and mind wake up
          renewed every day.
        </p>
        {/* Mattress Type Order Single or Dou */}
        <div className="space-y-3">
          {/* Single */}
          <div
            onClick={() => setSelectedType("single")}
            className={`w-full  rounded-lg p-4 sm:p-2 cursor-pointer  flex items-center sm:gap-2 gap-4  ${
              selectedType === "single"
                ? "border-[#204c97] border bg-[#dce9fc]"
                : "border-gray-400 border"
            }`}
          >
            <Radio
              checked={selectedType === "single"}
              value="single"
              sx={{
                color: "",
                "&.Mui-checked": { color: "#204c97" },
              }}
            />

            <div>
              <h4 className="text-[#333333]  font-lexend text-[16px] 3xl:text-[20px] sm:text-sm leading-none font-semibold">
                Mellow Soft Mattress
              </h4>
              <p className="text-[#6d6d6d] xl:text-sm md:text-base text-sm  font-lexend">
                For those who love sinking into rest
              </p>
            </div>
          </div>

          {/* Duo */}
          <div
            onClick={() => setSelectedType("duo")}
            className={`w-full  rounded-lg p-4 sm:p-2 cursor-pointer flex items-center sm:gap-2 gap-4 ${
              selectedType === "duo"
                ? "border-[#204c97] border bg-[#dce9fc]"
                : "border-gray-400 border"
            }`}
          >
            <Radio
              checked={selectedType === "duo"}
              value="duo"
              sx={{
                color: "",
                "&.Mui-checked": { color: "#204c97" },
              }}
            />

            <div>
              <h4 className="text-[#333333] xl:text-[16px] 3xl:text-[20px] sm:text-sm  leading-none font-lexend font-semibold">
                Mellow Soft Duo Mattress
              </h4>
              <p className="text-[#6d6d6d] text-sm 3xl:text-base  font-lexend">
                For those who like softness with flexibility
              </p>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-1 grid-cols-2 gap-2 xl:gap-7">
          <div className="w-full">
            <h3 className="font-semibold font-lexend text-[12px] xl:text-[16px] 3xl:text-running text-[#333333] py-3">
              Select your thickness
            </h3>
            <div className="relative w-full" ref={thicknessRef}>
              <button
                type="button"
                onClick={() => setDropdownThickNess(!dropdownThickNess)}
                className="w-full border border-gray-400 rounded-lg p-3 xl:p-4 text-left flex  gap-2 xl:gap-0 justify-between items-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#204b97] focus:border-[#204b97]"
              >
                <span className="flex items-center gap-5 sm:px-1 px-4">
                  <img
                    src={selectedThickness?.inactiveIcon}
                    alt={selectedThickness?.value}
                    className=""
                  />{" "}
                  <span className="font-semibold font-lexend text-[12px] md:text-[14px] xl:text-[16px] 3xl:text-running">
                    {" "}
                    {selectedThickness?.value} Inches{" "}
                  </span>
                </span>
                <svg
                  className={`w-5 h-5 text-gray-600 transition-transform duration-200 ${
                    dropdownThickNess ? "rotate-180" : ""
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* DROPDOWN MENU */}
              {dropdownThickNess && (
                <ul className="absolute z-10 mt-2 w-full bg-white border flex flex-col gap-2 border-gray-200 rounded-lg shadow-lg font-lexend">
                  {thicknessOptions.map((item) => (
                    <li
                      key={item.value}
                      onClick={() => {
                        setSelectedThickness(item);
                        setDropdownThickNess(false);
                      }}
                      className="flex items-center gap-5 sm:py-2 cursor-pointer py-3 px-8 sm:px-4 hover:bg-[#f3f4f6]"
                    >
                      <img
                        src={item?.inactiveIcon}
                        alt={item?.value}
                        className=""
                      />{" "}
                      <span className="font-semibold font-lexend text-[14px] md:text-[16px] 3xl:text-running">
                        {" "}
                        {item?.value} Inches{" "}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="w-full">
            <h3 className="font-semibold font-lexend text-[12px] xl:text-[16px] 3xl:text-running text-[#333333] py-3">
              Select your size
            </h3>
            <div className="relative w-full" ref={sizeRef}>
              <button
                type="button"
                onClick={() => setDropdowSize(!dropdownSize)}
                className="w-full border border-gray-400 rounded-lg p-3 md:p-2.5 xl:p-[13px] text-left flex  gap-2 xl:gap-0 justify-between items-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#204b97] focus:border-[#204b97]"
              >
                <span className="flex items-center gap-5 sm:px-1 px-4">
                  <img
                    src={selectedSize?.inactiveIcon}
                    alt={selectedSize?.value}
                    className=""
                  />{" "}
                  <span className="font-semibold font-lexend text-[12px] md:text-[14px] xl:text-[16px] 3xl:text-running">
                    {" "}
                    {selectedSize?.value}
                  </span>
                </span>
                <svg
                  className={`w-5 h-5 text-gray-600 transition-transform duration-200 ${
                    dropdownSize ? "rotate-180" : ""
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* DROPDOWN MENU */}
              {dropdownSize && (
                <ul className="absolute z-10 mt-2 w-full bg-white border flex flex-col gap-2 border-gray-200 rounded-lg shadow-lg font-lexend">
                  {SizeOptions.map((item) => (
                    <li
                      key={item.value}
                      onClick={() => {
                        setSelectedSize(item);
                        setDropdowSize(false);
                      }}
                      className="flex items-center gap-5 cursor-pointer sm:py-2 py-3 px-8 sm:px-4 hover:bg-[#f3f4f6]"
                    >
                      <img
                        src={item?.inactiveIcon}
                        alt={item?.value}
                        className=""
                      />{" "}
                      <span className="font-semibold font-lexend text-[14px] md:text-[16px] 3xl:text-running">
                        {" "}
                        {item?.value} Inches{" "}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
        {/* DIMENSIONS */}
        <div>
          <h3 className="font-semibold font-lexend text-[12px] xl:text-[16px] 3xl:text-running text-[#333333] py-3">
            Select your dimensions
          </h3>

          <div className="grid grid-cols-1  md:grid-cols-2 gap-8 items-center  gap-y-4 relative">
            {/* DIMENSION DROPDOWN */}
            <div className="relative w-full" ref={dimensionRef}>
              <button
                type="button"
                onClick={() => setCustomDropdownOpen(!customDropdownOpen)}
                className="w-full border border-gray-400 rounded-lg p-3 xl:p-5 text-left flex justify-center gap-2 xl:gap-0 xl:justify-between items-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#204b97] focus:border-[#204b97]"
              >
                <span className="text-[#333333] text-[12px] md:text-[16px] 3xl:text-running">
                  <span className="font-semibold font-lexend">
                    {selectedDimension.labelInch}
                  </span>{" "}
                  <span className="font-light font-lexend text-[12px] md:text-[16px] 3xl:text-running text-[#333333]">
                    {selectedDimension.labelCm}
                  </span>
                </span>
                <svg
                  className={`w-5 h-5 text-gray-600 transition-transform duration-200 ${
                    customDropdownOpen ? "rotate-180" : ""
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* DROPDOWN MENU */}
              {customDropdownOpen && (
                <ul className="absolute z-10 mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-lg font-lexend">
                  {dimensionOptions.map((opt) => (
                    <li
                      key={opt.value}
                      onClick={() => {
                        setSelectedDimension(opt);
                        setCustomDropdownOpen(false);
                        setCustomSizeActive(false);
                      }}
                      className="p-3 cursor-pointer text-black hover:bg-gray-100"
                    >
                      <span className="font-semibold font-lexend text-[#333333] text-[12px] md:text-[16px] 3xl:text-running">
                        {opt.labelInch}
                      </span>{" "}
                      <span className="font-light font-lexend text-[12px] md:text-[16px] 3xl:text-running text-[#333333]">
                        {opt.labelCm}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* CUSTOM SIZE BUTTON (FIXED) */}
            <div
              onClick={() => {
                setCustomSizeActive(!customSizeActive);
                setCustomDropdownOpen(false);
                setOpenDialog(true);
                if (!customSizeActive) {
                  setSelectedDimension({
                    value: "",
                    labelInch: "Custom Size",
                    labelCm: "",
                  });
                }
              }}
              className={`cursor-pointer flex gap-2 xl:gap-7 items-center justify-center border rounded-lg p-3 xl:p-5 transition-all duration-200 ${
                customSizeActive
                  ? "bg-[#dce9fc] border-[#204b97]"
                  : "border-gray-400 hover:border-[#204b97]"
              }`}
            >
              <img
                src={customSizeActive ? CustomSizeActive : CustomSizeInActive}
                alt="Custom Size"
              />
              <p
                className={`font-semibold font-lexend text-[12px] md:text-[16px] 3xl:text-running ${
                  customSizeActive ? "text-[#204b97]" : "text-[#333333]"
                }`}
              >
                Your custom size
              </p>
            </div>
            <CustomSizeModalBox
              open={openDialog}
              handleClose={() => setOpenDialog(false)}
            />
            <div>
              <div className="flex gap-2 border border-[#c6b484]  py-1 bg-[#f4e391] justify-center items-center text-center rounded-lg">
                <YouTubeIcon className="text-[#7a6f42]" />
                <p className="text-[12px] md:text-[15px] font-light font-lexend text-[#7a6f42] ">
                  Measure the right mattress size
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* COVER DROPDOWN */}
        {/* <div>
          <h3 className="font-semibold font-lexend text-[12px] xl:text-[16px] 3xl:text-running text-[#333333] py-3">
            Select a Cover
          </h3>

          <div className="relative  w-full md:w-[80%]" ref={coverRef}>
            <button
              type="button"
              onClick={() => setCoverDropdownOpen(!coverDropdownOpen)}
              className="w-full border border-gray-300 rounded-lg p-2 xl:p-4 text-left flex  justify-between items-center cursor-pointer focus:outline-none focus:ring-1 focus:ring-[#204b97] focus:border-[#204b97]"
            >
              <div className="flex items-center gap-5 xl:gap-10">
                <img
                  src={selectedCover.image}
                  alt={selectedCover.label}
                  className=" rounded-md object-center  h-[60px] w-auto xl:h-auto"
                />
                <div>
                  <p className="font-semibold font-lexend text-[12px] md:text-[16px] 3xl:text-running text-[#333333]">
                    {selectedCover.label}
                  </p>
                  <p className="text-[#333333] font-light font-lexend  text-[12px] md:text-[16px] 3xl:text-running">
                    ({selectedCover.description})
                  </p>
                </div>
              </div>

              <svg
                className={`w-7 h-7 text-gray-400 transition-transform duration-200 ${
                  coverDropdownOpen ? "rotate-180" : ""
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>

            {coverDropdownOpen && (
              <ul className="absolute  mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                {coverOptions.map((opt) => (
                  <li
                    key={opt.value}
                    onClick={() => {
                      setSelectedCover(opt);
                      setCoverDropdownOpen(false);
                    }}
                    className="flex items-center gap-4 p-3 hover:bg-gray-100 cursor-pointer"
                  >
                    <img
                      src={opt.image}
                      alt={opt.label}
                      className=" h-[60px] rounded-md object-cover"
                    />
                    <div>
                      <p className="font-semibold font-lexend text-[12px] md:text-[16px] 3xl:text-running text-[#333333]">
                        {opt.label}
                      </p>
                      <p className="text-[#333333] font-light font-lexend  text-[12px] md:text-[16px] 3xl:text-running">
                        {opt.description}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div> */}

        {/* PRICE SECTION */}
        <div className="flex flex-wrap items-end gap-x-5 mt-6 xl:mt-12 ">
          <h2 className="text-[24px] xl:text-[40px] font-normal font-calsans text-[#333333]">
            ₹44,480
          </h2>

          <p className="text-[#a2a19f] font-light font-lexend text-[14px] xl:text-[22px] line-through tracking-wide">
            MRP ₹59,300
          </p>

          <p className="text-[#5f9c4e] text-[14px] xl:text-[22px] font-semibold font-lexend tracking-wide">
            40% off
          </p>

          <p className="text-[#a2a19f] font-light font-lexend text-[14px] xl:text-[20px] tracking-wide">
            (Incl of all Taxes)
          </p>
        </div>

        {/* QUANTITY & ADD TO CART */}
        <div className="flex justify-between gap-3 xl:gap-5 mt-6">
          {/* Quantity */}
          <div className="flex items-center justify-between border border-[#204b97] rounded-md overflow-hidden w-full md:w-[25%] xl:w-[50%] h-[42px] xl:h-auto">
            <button
              onClick={() => setQuantity((prev) => (prev > 1 ? prev - 1 : 1))}
              className="px-4 xl:px-5 py-5 bg-[#eaf1ff] text-[#204b97] text-[12px] md:text-[16px] xl:text-[20px] font-bold hover:bg-[#dce9fc] transition"
            >
              -
            </button>

            <div className="px-4 xl:px-5 py-4 text-[12px] md:text-[14px] xl:text-[18px] font-semibold font-lexend text-[#333333] bg-white">
              {quantity}
            </div>

            <button
              onClick={() => setQuantity((prev) => prev + 1)}
              className="px-4 xl:px-5 py-5 bg-[#eaf1ff] text-[#204b97] text-[12px] md:text-[16px] xl:text-[20px] font-bold hover:bg-[#dce9fc] transition"
            >
              +
            </button>
          </div>

          {/* Add to Cart */}
          <button
            onClick={() => setOpenAddons(true)}
            className="
      flex items-center justify-center gap-2 xl:gap-7
      bg-[#204b97] text-white
      text-[14px] lg:text-xl md:text-lg xl:text-2xl 3xl:text-[32px]
      font-normal font-calsans
      h-[42px] xl:h-auto
      px-3 md:px-10
      rounded-md
      hover:bg-[#183b79] transition-all duration-200
      w-full md:w-[70%] xl:w-full
      mt-0 xl:mt-0
    "
          >
            <ShoppingCartIcon className="text-[20px] md:text-[24px] xl:text-[35px] text-[#adccfb]" />
            Add to Cart
          </button>
        </div>

        {/* EMI SECTION */}
        <div className="flex items-center justify-between border border-[#c6b484] rounded-md bg-[#f4e391] mt-5 overflow-hidden font-lexend">
          <div className="bg-[#f4e391] w-[35%] flex items-center justify-center py-2 xl:py-4 font-semibold text-[9px] md:text-[14px] xl:text-[20px] text-[#7d6e47] italic">
            BUY ON EMI
          </div>
          <div className="bg-[#f7f1e1] xs:w-full sm:w-[65%] md:w-[65%] text-center py-2 xl:py-4  text-[#7c6e47] text-[9px] xl:text-[17px] font-light tracking-wide">
            or Pay{" "}
            <span className="font-semibold text-[9px] xl:text-[20px]">
              ₹2775
            </span>{" "}
            now & rest in 0% EMIs Order
          </div>
        </div>
      </div>
      <AddonsOffCanvas
        isOpen={openAddons}
        onClose={() => setOpenAddons(false)}
      />
      {shareOpen && (
        <div
          className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40"
          onClick={() => setShareOpen(false)}
        >
          <div
            className="bg-white rounded-2xl w-[90%] max-w-md p-6 relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="flex justify-between items-center border-b pb-3">
              <h3 className="text-lg font-semibold font-lexend">Share</h3>
              <button
                onClick={() => setShareOpen(false)}
                className="text-gray-400 hover:text-gray-600 text-xl"
              >
                ✕
              </button>
            </div>
            {/* SOCIAL ICONS */}
            <p className="mt-4 text-[12px] xl:text-[18px] text-gray-600 font-lexend">
              Share this link via
            </p>

            <div className="flex font-lexend justify-between items-center mt-4 px-2">
              {/* Facebook */}
              <button
                onClick={() => handleShare("facebook")}
                className="xs:w-8 xs:h-8 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border hover:bg-blue-50 transition"
              >
                <FacebookOutlinedIcon sx={{ color: "#1877F2", fontSize: 26 }} />
              </button>

              {/* X / Twitter */}
              <button
                onClick={() => handleShare("twitter")}
                className="xs:w-8 xs:h-8 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border hover:bg-gray-100 transition"
              >
                <XIcon sx={{ color: "#000", fontSize: 24 }} />
              </button>

              {/* Instagram */}
              <button
                onClick={() => handleShare("instagram")}
                className="xs:w-8 xs:h-8 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border hover:bg-pink-50 transition"
              >
                <InstagramIcon sx={{ color: "#E4405F", fontSize: 26 }} />
              </button>

              {/* WhatsApp */}
              <button
                onClick={() => handleShare("whatsapp")}
                className="xs:w-8 xs:h-8 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border hover:bg-green-50 transition"
              >
                <WhatsAppIcon sx={{ color: "#25D366", fontSize: 26 }} />
              </button>

              {/* Telegram */}
              <button
                onClick={() => handleShare("telegram")}
                className="xs:w-8 xs:h-8 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border hover:bg-blue-50 transition"
              >
                <TelegramIcon sx={{ color: "#229ED9", fontSize: 26 }} />
              </button>

              {/* Email */}
              <button
                onClick={() =>
                  (window.location.href = `mailto:?subject=Check this product&body=${productUrl}`)
                }
                className="xs:w-8 xs:h-8 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border hover:bg-gray-100 transition"
              >
                <EmailIcon sx={{ color: "#6B7280", fontSize: 26 }} />
              </button>
            </div>

            {/* COPY LINK */}
            <p className="mt-6 text-[12px] xl:text-[18px] text-gray-600 font-lexend">
              Or copy link
            </p>

            <div className="flex font-lexend items-center gap-2 mt-2">
              <input
                type="text"
                readOnly
                value={productUrl}
                className="flex-1 border rounded-lg px-3 py-2 text-[12px] xl:text-[16px] text-gray-600"
              />
              <button
                onClick={handleCopyLink}
                className="bg-[#f4e391] text-[#2b5530] px-4 py-2 rounded-lg text-[12px] xl:text-[18px] font-bold"
              >
                {copied ? "Copied" : "Copy"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
